import React from 'react';

export function InfoCircleIcon({ className, width = 20, height = 20 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5126_386)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99996 2.41699C5.8118 2.41699 2.41663 5.81217 2.41663 10.0003C2.41663 14.1885 5.8118 17.5837 9.99996 17.5837C14.1881 17.5837 17.5833 14.1885 17.5833 10.0003C17.5833 5.81217 14.1881 2.41699 9.99996 2.41699ZM0.916626 10.0003C0.916626 4.98374 4.98337 0.916992 9.99996 0.916992C15.0165 0.916992 19.0833 4.98374 19.0833 10.0003C19.0833 15.0169 15.0165 19.0837 9.99996 19.0837C4.98337 19.0837 0.916626 15.0169 0.916626 10.0003ZM9.24996 6.66699C9.24996 6.25278 9.58575 5.91699 9.99996 5.91699H10.0083C10.4225 5.91699 10.7583 6.25278 10.7583 6.66699C10.7583 7.08121 10.4225 7.41699 10.0083 7.41699H9.99996C9.58575 7.41699 9.24996 7.08121 9.24996 6.66699ZM9.99996 9.25033C10.4142 9.25033 10.75 9.58611 10.75 10.0003V13.3337C10.75 13.7479 10.4142 14.0837 9.99996 14.0837C9.58575 14.0837 9.24996 13.7479 9.24996 13.3337V10.0003C9.24996 9.58611 9.58575 9.25033 9.99996 9.25033Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99996 2.41699C5.8118 2.41699 2.41663 5.81217 2.41663 10.0003C2.41663 14.1885 5.8118 17.5837 9.99996 17.5837C14.1881 17.5837 17.5833 14.1885 17.5833 10.0003C17.5833 5.81217 14.1881 2.41699 9.99996 2.41699ZM0.916626 10.0003C0.916626 4.98374 4.98337 0.916992 9.99996 0.916992C15.0165 0.916992 19.0833 4.98374 19.0833 10.0003C19.0833 15.0169 15.0165 19.0837 9.99996 19.0837C4.98337 19.0837 0.916626 15.0169 0.916626 10.0003ZM9.24996 6.66699C9.24996 6.25278 9.58575 5.91699 9.99996 5.91699H10.0083C10.4225 5.91699 10.7583 6.25278 10.7583 6.66699C10.7583 7.08121 10.4225 7.41699 10.0083 7.41699H9.99996C9.58575 7.41699 9.24996 7.08121 9.24996 6.66699ZM9.99996 9.25033C10.4142 9.25033 10.75 9.58611 10.75 10.0003V13.3337C10.75 13.7479 10.4142 14.0837 9.99996 14.0837C9.58575 14.0837 9.24996 13.7479 9.24996 13.3337V10.0003C9.24996 9.58611 9.58575 9.25033 9.99996 9.25033Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5126_386">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
